import { render } from "./dataScience.vue?vue&type=template&id=6f0771d4"
const script = {}

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__